import { render } from "./Siddur.vue?vue&type=template&id=3e8c5366"
import script from "./Siddur.vue?vue&type=script&lang=js"
export * from "./Siddur.vue?vue&type=script&lang=js"

import "./Siddur.vue?vue&type=style&index=0&id=3e8c5366&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__